import {useUserStore} from "@/app/stores/user-store.ts";
import MD5 from 'md5';

export class userLocalStorage {
    private static readonly UNDEFINED_STRING = 'undefined';

    public static getItem<T>(key: string) {
        const localStorageHash = this.getHashedUserId();
        const value = localStorage.getItem(`${key}_${localStorageHash}`);
        if (value === this.UNDEFINED_STRING || value === null) {
            return null;
        }
        try {
            return value ? JSON.parse(value) as T : null;
        } catch (e) {
            return null;
        }
    }

    public static setItem<T>(key: string, value: T): void {
        const serialized = JSON.stringify(value);
        const localStorageHash = this.getHashedUserId();
        localStorage.setItem(`${key}_${localStorageHash}`, serialized);
    }

    private static getHashedUserId(): string {
        const userId = useUserStore().userId;
        if (userId) {
            return MD5(`${userId}`);
        }
        return '';
    }

    public static appendItemToArray(key: string, value: any): void {
        let storedValue: string[] = this.getItem(key) as [];
        if (!storedValue) {
            storedValue = [];
        }
        storedValue.push(value);

        const serialized = JSON.stringify(storedValue);
        localStorage.setItem(`${key}_${this.getHashedUserId()}`, serialized);
    }
}
